import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
// Organization note labels use the existing Platform tenant-copy resolver.
export const relationshipsOrganizationNotesCopySchema = z.strictObject({
    title: z.string().trim().min(1).max(500),
    empty: z.string().trim().min(1).max(500),
    loading: z.string().trim().min(1).max(500),
    loadError: z.string().trim().min(1).max(500),
    denied: z.string().trim().min(1).max(500),
    add: z.string().trim().min(1).max(500),
    body: z.string().trim().min(1).max(500),
    type: z.string().trim().min(1).max(500),
    pinned: z.string().trim().min(1).max(500),
    pin: z.string().trim().min(1).max(500),
    unpin: z.string().trim().min(1).max(500),
    remove: z.string().trim().min(1).max(500),
    confirm: z.string().trim().min(1).max(500),
    confirmDelete: z.string().trim().min(1).max(500),
    cancel: z.string().trim().min(1).max(500),
    save: z.string().trim().min(1).max(500),
    saving: z.string().trim().min(1).max(500),
    invalid: z.string().trim().min(1).max(500),
    uncertain: z.string().trim().min(1).max(500),
    saved: z.string().trim().min(1).max(500),
    submitted: z.string().trim().min(1).max(500),
    updated: z.string().trim().min(1).max(500),
    deleted: z.string().trim().min(1).max(500),
    check: z.string().trim().min(1).max(500),
    refresh: z.string().trim().min(1).max(500),
    previous: z.string().trim().min(1).max(500),
    next: z.string().trim().min(1).max(500),
    general: z.string().trim().min(1).max(500),
    call: z.string().trim().min(1).max(500),
    site_visit: z.string().trim().min(1).max(500),
    internal: z.string().trim().min(1).max(500),
    ai_generated: z.string().trim().min(1).max(500),
    status_update: z.string().trim().min(1).max(500),
});
export const relationshipsOrganizationNotesCopySetting = definePlatformSetting({
    definition: {
        key: 'relationships.copy.organization-notes', moduleId: 'relationships',
        title: 'Organization notes interface copy', helpText: 'Labels for organization note history and actions.',
        configurationDomain: 'copy', valueType: 'object', schemaVersion: 1,
        codedFallback: {
            "title": "Organization notes",
            "empty": "No organization notes yet.",
            "loading": "Loading organization notes…",
            "loadError": "Organization notes could not be loaded.",
            "denied": "You do not have permission to read organization notes.",
            "add": "Add organization note",
            "body": "Note",
            "type": "Note type",
            "pinned": "Pinned",
            "pin": "Pin note",
            "unpin": "Unpin note",
            "remove": "Delete note",
            "confirm": "Delete this note permanently? This cannot be undone.",
            "confirmDelete": "Confirm deletion",
            "cancel": "Cancel",
            "save": "Save note",
            "saving": "Saving…",
            "invalid": "Enter a note of 1–10,000 characters.",
            "uncertain": "The change could not be confirmed. Check the history before starting another change; this request will not be retried automatically.",
            "saved": "Note saved and checked.",
            "submitted": "Note saved by the server; your role cannot read the history to verify it.",
            "updated": "Note pin checked.",
            "deleted": "Note deletion checked.",
            "check": "Check current note",
            "refresh": "Refresh notes",
            "previous": "Previous notes",
            "next": "Next notes",
            "general": "General",
            "call": "Call",
            "site_visit": "Site visit",
            "internal": "Internal",
            "ai_generated": "AI generated",
            "status_update": "Status update"
        },
        permittedScopes: ['platform', 'plan', 'tenant'], mergeStrategy: 'deep-merge',
        clientSafe: true, serverOnly: false, sensitive: false, tenantEditable: true,
        userOverridable: false, offlineEligible: true, safetyClass: 'ordinary',
    },
    valueSchema: relationshipsOrganizationNotesCopySchema,
});
//# sourceMappingURL=relationships-organization-notes-copy.js.map